<template>
  <div class="align-items-center">
    <button class="btn btn-secondary btn-sm" v-on:click="print()">
      <BaseIcon name="printer" />
    </button>
  </div>
</template>
<script>
import BaseIcon from "@/components/icons/BaseIcon";
import { useStore } from "vuex";
import tenant from "../../../modules/tenant";

export default {
  name: "ManufacturingOperationPrints",
  components: { BaseIcon },
  props: {
    id: Number,
    row: Object,
    modelValue: Number,
  },
  data() {
    return {
      store: useStore(),
    };
  },
  methods: {
    print() {
      window.open(
        `${tenant.getApiBaseUrl()}/products/manufacturing-operations/pdf?_token=${
          this.store.state.token
        }&id[]=${this.modelValue}`,
        "_blank"
      );
    },
  },
};
</script>
